"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picker = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _ListItemText = _interopRequireDefault(require("../ListItemText"));
var _Select = require("../Select");
var _SelectDropdown = _interopRequireWildcard(require("../SelectDropdown"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onChange", "onClose", "onOpen", "open", "selectedOptions", "chaneStrategy", "disabled", "isOptionDisabled", "button", "getOptionLabel", "getOptionValue", "getOptionInfo", "getOptionIconInfo", "options", "loading", "renderOption", "withSelectAll", "onDropdownFocus", "withFilter", "addOptionLabel", "onAdd", "width", "widthAuto", "disableAutoFocus", "disableEnforceFocus", "groupBy", "showCheckbox", "closeOnSelect"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Picker = exports.Picker = function Picker(_ref) {
  var onChangeProp = _ref.onChange,
    onCloseProp = _ref.onClose,
    onOpenProp = _ref.onOpen,
    openProp = _ref.open,
    selectedOptionsProp = _ref.selectedOptions,
    _ref$chaneStrategy = _ref.chaneStrategy,
    chaneStrategy = _ref$chaneStrategy === void 0 ? 'select' : _ref$chaneStrategy,
    disabled = _ref.disabled,
    isOptionDisabled = _ref.isOptionDisabled,
    button = _ref.button,
    _ref$getOptionLabel = _ref.getOptionLabel,
    getOptionLabel = _ref$getOptionLabel === void 0 ? _SelectDropdown.defaultGetOptionLabel : _ref$getOptionLabel,
    _ref$getOptionValue = _ref.getOptionValue,
    getOptionValue = _ref$getOptionValue === void 0 ? _SelectDropdown.defaultGetOptionValue : _ref$getOptionValue,
    _ref$getOptionInfo = _ref.getOptionInfo,
    getOptionInfo = _ref$getOptionInfo === void 0 ? _Select.defaultGetOptionInfo : _ref$getOptionInfo,
    _ref$getOptionIconInf = _ref.getOptionIconInfo,
    getOptionIconInfo = _ref$getOptionIconInf === void 0 ? _Select.defaultGetOptionIconInfo : _ref$getOptionIconInf,
    options = _ref.options,
    loading = _ref.loading,
    renderOptionProp = _ref.renderOption,
    _ref$withSelectAll = _ref.withSelectAll,
    withSelectAll = _ref$withSelectAll === void 0 ? false : _ref$withSelectAll,
    onDropdownFocus = _ref.onDropdownFocus,
    _ref$withFilter = _ref.withFilter,
    withFilter = _ref$withFilter === void 0 ? true : _ref$withFilter,
    addOptionLabel = _ref.addOptionLabel,
    onAdd = _ref.onAdd,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 300 : _ref$width,
    widthAuto = _ref.widthAuto,
    disableAutoFocus = _ref.disableAutoFocus,
    disableEnforceFocus = _ref.disableEnforceFocus,
    groupBy = _ref.groupBy,
    showCheckbox = _ref.showCheckbox,
    _ref$closeOnSelect = _ref.closeOnSelect,
    closeOnSelect = _ref$closeOnSelect === void 0 ? true : _ref$closeOnSelect,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    displayNode = _useState2[0],
    setDisplayNode = _useState2[1];
  // const [openState, setOpenState] = useState(() => false);
  // const controlled = openProp !== undefined;
  // const open = controlled ? openProp : openState;
  //
  // const toggleOpen = (state) => {
  //   if (!controlled) {
  //     setOpenState(state);
  //   }
  //   if (state) {
  //     onOpen?.();
  //   } else {
  //     onClose?.();
  //   }
  // };
  //
  // const handleOpen = () => toggleOpen(true);
  // const handleChange = (...args) => {
  //   onChange(...args);
  //   if(closeOnSelect){
  //
  //     toggleOpen(false);
  //   }
  // };

  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    _buttonElement = _useState4[0],
    setButton = _useState4[1];
  var _useSelectState = (0, _Select.useSelectState)({
      onChange: onChangeProp,
      value: selectedOptionsProp,
      onOpen: onOpenProp,
      onClose: onCloseProp,
      chaneStrategy: chaneStrategy
    }),
    open = _useSelectState.open,
    selectedOptions = _useSelectState.selectedOptions,
    onChange = _useSelectState.onChange,
    onClose = _useSelectState.onClose,
    onOpen = _useSelectState.onOpen;
  var buttonComponent = /*#__PURE__*/React.cloneElement(button, {
    onClick: disabled ? undefined : onOpen,
    disabled: disabled,
    ref: setButton
  });
  var buttonWidth = _buttonElement === null || _buttonElement === void 0 ? void 0 : _buttonElement.offsetWidth;
  var filter = (0, _Select.useFilterOptions)({
    stringify: function stringify(option) {
      return "".concat(getOptionLabel(option));
    }
  });
  var renderOption = (0, _react.useCallback)(function (option, _ref2) {
    var selected = _ref2.selected,
      focused = _ref2.focused,
      index = _ref2.index,
      disabled = _ref2.disabled;
    var content = null;
    if (renderOptionProp) {
      content = renderOptionProp(option, {
        selected: selected,
        focused: focused,
        disabled: disabled,
        index: index
      });
    } else {
      var label = getOptionLabel(option);
      var value = getOptionValue(option);
      content = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        "data-cy": "picker-option-".concat(value),
        primary: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          noWrap: true,
          children: label
        })
      });
    }
    var optionInfo = getOptionInfo(option);
    var optionIconInfo = getOptionIconInfo(option);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Option, {
      optionInfo: optionInfo,
      optionIconInfo: optionIconInfo,
      selected: selected,
      showCheckbox: showCheckbox,
      disabled: disabled,
      children: content
    });
  }, [renderOptionProp, options, getOptionLabel, showCheckbox]);
  var renderGroup = React.useCallback(function (group) {
    var label = group.groupKey;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
      id: group.groupKey,
      primary: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
        noWrap: true,
        variant: 'subtitle2',
        children: label
      })
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      ref: setDisplayNode,
      children: buttonComponent
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectDropdown["default"], _objectSpread({
      withSelectAll: withSelectAll,
      addOptionLabel: addOptionLabel,
      groupBy: groupBy,
      onAdd: onAdd,
      canDeselect: false,
      open: !!(open && !loading),
      options: options,
      displayNode: displayNode,
      renderOption: renderOption,
      renderGroup: renderGroup,
      filterOption: filter,
      onClose: onClose,
      onChange: onChange,
      width: widthAuto ? buttonWidth : width,
      withFilter: withFilter,
      onDropdownFocus: onDropdownFocus,
      isOptionDisabled: isOptionDisabled,
      disableAutoFocus: disableAutoFocus,
      disableEnforceFocus: disableEnforceFocus,
      getOptionValue: getOptionValue,
      selectedOptions: selectedOptions
    }, props))]
  });
};